import { render, staticRenderFns } from "./xgtx.vue?vue&type=template&id=99cea0be"
import script from "./xgtx.vue?vue&type=script&lang=js"
export * from "./xgtx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports